import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { DxTabPanelComponent } from 'devextreme-angular';
import { Constants, SearchOperations } from 'src/app/app.constants';
import { AlertService } from 'src/app/core/alert.service';
import { AuthService } from 'src/app/core/auth.service';
import { DialogService } from 'src/app/core/dialog.service';
import { LoadingService } from 'src/app/core/loading.service';
import { RequestService } from 'src/app/core/request.service';
import { UtilityService } from 'src/app/core/utility.service';
import { BaseListComponent } from 'src/app/shared/base/base-list.component';
import { RouteAuthorities, ValueLabel } from 'src/app/shared/base/base.models';
import { BaseService } from 'src/app/shared/base/base.service';
import { UserType } from '../../users/users.models';
import { RegistrationKey, RegistrationsRequestsStatus, RegistrationsRequests } from '../registrations-requests.models';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import CustomStore from 'devextreme/data/custom_store';
import { OptionsSource } from 'src/app/core/core.models';
import { BusinessPartnersService } from '../../business-partners/business-partners.service';
import { BusinessPartner } from '../../business-partners/business-partners.models';
import { RegistrationsRequestsService } from '../registrations-requests.service';

@Component({
  selector: 'app-registrations-requests-list',
  templateUrl: './registrations-requests-list.component.html',
  styleUrls: ['./registrations-requests-list.component.scss']
})
export class RegistrationsRequestsListComponent extends BaseListComponent implements OnInit, OnDestroy {
  public gridStateKey: string = 'registrations_requests_new_list_grid_state';
  public lookupColumns: Array<string> = ['businessPartner.name', 'note', 'email', 'suggestionName', 'idNumber', 'name', 'relatedEntity', 'telephone'];

  public tabs: RegistrationsRequestsStatus[] = [
    RegistrationsRequestsStatus.NEW,
    RegistrationsRequestsStatus.APPROVED,
    RegistrationsRequestsStatus.DECLINED
  ];

  public dataSources: any = {
    NEW: null,
    APPROVED: null,
    DECLINED: null
  };

  public locationSubscription: Subscription;
  public activeTab: RegistrationsRequestsStatus;
  public RegistrationsRequestsStatus = RegistrationsRequestsStatus;
  public userTypes: ValueLabel[] = [];
  public approveRegistrationData: RegistrationsRequests = null;
  public declineRegistrationData: RegistrationsRequests = null;
  public businessPartners: OptionsSource;
  public selectedBusinessPartner: BusinessPartner; 
  public note: string;

  constructor(
    public authService: AuthService,
    public loadingService: LoadingService,
    public baseService: BaseService,
    public dialogService: DialogService,
    public alertService: AlertService,
    public utilityService: UtilityService,
    public requestService: RequestService,
    public translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private businessPartnerService: BusinessPartnersService,
    private registrationsRequestsService: RegistrationsRequestsService
    ) {
    super(authService, loadingService, baseService, dialogService, alertService, utilityService, requestService, translateService);
    this.authorities = new RouteAuthorities(authService, alertService, 'RA_RGST_RQST', null, null, 'RA_RGST_RQST');
    this.creatable = this.authorities.create;
    this.editable = this.authorities.update;
    this.deletable = this.authorities.delete;
    this.activatable = this.authorities.update;
  }

  ngOnInit(): void {
    this.url = `${Constants.contextPath}/registration-requests`;
    this.prepareLookupData();
    this.locationSubscription = this.activatedRoute.params.subscribe(routeParams => {
      if(routeParams && routeParams.type)
        this.getTabData(routeParams.type.toUpperCase(), true)
      });
  }

  ngOnDestroy(){
    this.locationSubscription.unsubscribe();
  }
  
  navigateTo(e){
    let tab = e.addedItems[0].toUpperCase();
    if(tab == this.activeTab) return;
    this.router.navigate(['/registration-requests/'+tab.toLowerCase()]);
  }

  public prepareLookupData() {
    this.userTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(UserType, true), 'value', 'label', 'ENUMS.USER-TYPES.');
    this.businessPartners = this.businessPartnerService.getBusinessPartnerLookup();
  }

  public getTabData(tab, force: boolean = false): void {
    this.gridStateKey = `registrations_requests_${tab.toLowerCase()}_list_grid_state`;
    this.activeTab = tab;

    this.dataSources[tab] = new CustomStore({
      key: 'id',
      load: (loadOptions: any) => this.loadGridData(loadOptions, `status${SearchOperations.EQUALITY}${tab}`, force),
      byKey: () => null
    });
  }

  public loadGridState = (): any => {
    return this.loadGridStateBase(this.gridStateKey, this.lookupColumns);
  }

  public saveGridState = (state: any): void => {
    this.saveGridStateBase(state, this.gridStateKey, this.lookupColumns);
  }

  public approveRegistration() {
    this.registrationsRequestsService.approveRegistration(this.approveRegistrationData, this.selectedBusinessPartner[0].id, () => {
      this.alertService.success('REGISTRATIONS.SUCCESSFULLY_CONFIRMED');
      this.approveRegistrationData = null;
      this.selectedBusinessPartner = null;
      this.getTabData(this.activeTab, true);
    });
  };
  
  public declineRegistration() {
    this.registrationsRequestsService.rejectRegistration(this.declineRegistrationData, this.note, () => {
      this.alertService.success('REGISTRATIONS.SUCCESSFULLY_REJECTED');
      this.declineRegistrationData = null;
      this.note = null;
      this.getTabData(this.activeTab, true);
    });    
  };
}
